
/**
 * Buffer d'action XML
 */

import { XmlLog } from "./XmlLog";
import { IsiXmlAction } from "./XmlAction";
import { XmlUserSettingsResult } from "./XmlUserSettingsResult";
import { IsiPlXmlUserSettings } from "../Isilog/PresentationLogic/IsiPlXmlUserSettings";
import { IsiDtoPlXmlUserSettingsResult } from "../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlXmlUserSettings";

export class IsiXmlBuffer {
    private static readonly XML_ALL_AT_ONCE = "XMLALLATONCE";
    private _log: XmlLog;
    private _orderedActions: IsiXmlAction[];
    private _dictionaryActions: {};
    private _uniqueId: string = "none";
    currentActionIndex: number;

    public constructor() {
        this._clearBuffer();
        this._log = new XmlLog('XmlBuffer');
    }

    /**
     * Vide le buffer
     */
    private _clearBuffer() {
        this._orderedActions = [];
        this._dictionaryActions = {};
        this.currentActionIndex = 0;
    }

    /**
     * Ajoute une action au buffer
     * @param {string} xmlType
     * @param {string} linkedCtrlValues
     * @param {string} ctrlId
     * @param {string} triggerId
     * @param {string} ctrlValue
     */
    public addAction(uniqueId: string, xmlType: string, linkedCtrlValues: string, ctrlId: string, triggerId: string, ctrlValue: string) {

        this._log.setId(uniqueId);
        this._log.log("addAction : ajout de l'action " + xmlType + ", ctrl=" + ctrlId + ", value=" + ctrlValue + ", trigger=" + triggerId); // XML_BUFFER
        //this._log.log("buffer : ajout de l'action " + linkedCtrlValues);

        let theAction = new IsiXmlAction();
        //  theAction.num = this.currentActionIndex++;
        theAction.type = xmlType;
        theAction.lnCv = linkedCtrlValues;
        theAction.ctrl = ctrlId;
        theAction.trig = triggerId;
        theAction.val = ctrlValue;

        this._orderedActions.push(theAction);
        if (typeof (this._dictionaryActions[ctrlId]) === "undefined") {
            this._dictionaryActions[ctrlId] = [];
        }
        this._dictionaryActions[ctrlId].push(theAction);
    }

    /**
     * Donne toutes les actions contenues dans le buffer, sérialisées
     */
    private _getSerializedActions() {

        let sJson = JSON.stringify(this._orderedActions);

        //this._log.log("buffer : SerializedActions = " + sJson); 

        return sJson;
    }

    /**
     * Envoie le contenu du buffer au serveur.
     * Appel du serveur pour le calcul de toutes les valeurs XML en une fois
     */
    public async flush(uniqueId: string, ctrlsDesignEvaluated) {

        if (!this._orderedActions || this._orderedActions.length <= 0) { return; }

        this._uniqueId = uniqueId;
        this._log.setId(this._uniqueId);
        this._log.log("flush nb actions : " + this._orderedActions.length);

        let actions = this._getSerializedActions();
        //actions = encodeURIComponent(actions);
        this._clearBuffer();

        this._log.log("flush appel  AJAX =============>");

        const pl = new IsiPlXmlUserSettings();
        const data: IsiDtoPlXmlUserSettingsResult = await pl.GetXmlUserSettings(IsiXmlBuffer.XML_ALL_AT_ONCE, actions);

        this._log.log("flush retour AJAX <=============");
        this._log.log("flush avant application des résultats");

        this._processFlushResult(data.value, ctrlsDesignEvaluated);

        this._log.log("flush apres application des résultats");
    }

    /**
     * Analyse et gère le résultat du flush (appel du serveur pour le calcul de toutes les valeurs XML)
     */
    private _processFlushResult(data: string, ctrlsDesignEvaluated) {

        this._log.log("handleResult");
           if (data && data.startsWith("ISIXMLERROR")) {
        this._log.log("Erreur détectée dans le retour AJAX : " + data);
               uiCore.logError("Erreur ISIXML", data);
       
               if (uiCore.getIsModeDiag()) {
                   uiCore.showMessage(data.replace(/(\r\n|\r|\n)/g, '<br>'), { popin: true });
               }
               return; 
    }
        let xus = new XmlUserSettingsResult(this._uniqueId);
        let flushData;
        try {
            flushData = Sys.Serialization.JavaScriptSerializer.deserialize(data);
        } catch (ex) {
            this._log.log("Error in xmlBuffer.handleResult data='" + data + "'");
            uiCore.logError("-", ex);
        }

        if (!flushData) { return; }

        for (let i = 0; i < flushData.length; ++i) {
            this._processOneFlushData(xus, flushData[i], ctrlsDesignEvaluated);
        }

    }

    /**
     * Gère une donnée du résultat du flush (appel du serveur pour le calcul de toutes les valeurs XML)
     */
    private _processOneFlushData(xus: XmlUserSettingsResult, data: any, ctrlsDesignEvaluated) {
        xus.evaluateXmlResult(data, ctrlsDesignEvaluated);
    }

}
